import React from 'react';
import { Button, Grid } from '@material-ui/core';

interface IProps {
  saveText: string;
  cancelText?: string;
  isSubmitting: boolean;
  onClose: () => void;
  onClick?: () => void;
}

const FormBtns: React.FC<IProps> = ({
  onClose,
  isSubmitting,
  saveText,
  cancelText = 'Cancel',
  onClick,
}) => {
  return (
    <Grid container item justify='flex-end' xs={12} sm={6}>
      <Button
        className='orangeLink'
        data-cy='cancel'
        disabled={isSubmitting}
        onClick={onClose}
      >
        {cancelText}
      </Button>

      <Button
        color='secondary'
        data-cy='changePassword'
        disabled={isSubmitting}
        type='submit'
      >
        {saveText}
      </Button>
    </Grid>
  );
};

export default FormBtns;
